import { z } from 'zod'

export const editQuestionSchema = z.object({
  question: z.string().min(1, 'Question is required'),
  idealAnswer: z
    .string()
    .min(50, 'Ideal Answer must be at least 50 characters'),
  evaluationCriteria: z
    .string()
    .min(50, 'Evaluation Criteria must be at least 50 characters'),
})

export type EditQuestionSchema = z.infer<typeof editQuestionSchema>
